import styled from 'styled-components';
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

export const SolutionsWrapper = styled.section`
  padding: 0 0 58px;

  text-align: center;

  background: rgb(${getToken('color-background-inverted')});

  ${screen.md} {
    padding: 0 0 34px;
  }

  ${screen.lg} {
    padding: 0 0 63px;
  }

  ${screen.xxlg} {
    padding: 0 0 100px;
  }
`;

export const Title = styled.h1`
  margin: 80px auto 0px;

  font-family: ${getToken('platform-font-title')};
  color: rgb(${getToken('color-brand')});
  font-weight: ${getToken('font-weight-bold')};
  font-size: 38px;
  line-height: 47px;
  text-align: center;

  ${screen.md} {
    font-size: 48px;
    line-height: 60px;
  }

  ${screen.xxlg} {
    margin-top: 100px;
  }
`;

export const SubTitle = styled.p`
  font-family: ${getToken('platform-font-title')};
  color: rgb(${getToken('color-text-inverted')});
  font-weight: ${getToken('font-weight-bold')};
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  margin: 32px auto 48px;

  br {
    display: none;
  }

  ${screen.md} {
    font-size: 26px;
    line-height: 39px;
  }

  ${screen.lg} {
    br {
      display: inline-block;
    }
  }
`;

export const Text = styled.p`
  margin: 32px 0px 48px;

  font-family: ${getToken('font-family-default')};
  color: rgb(${getToken('color-text-inverted')});
  font-weight: ${getToken('font-weight-regular')};
  font-size: 14px;
  line-height: 21px;
  text-align: center;

  ${screen.md} {
    margin: 32px 18px 48px;

    font-size: 20px;
    line-height: 36px;
  }

  ${screen.lg} {
    margin: 32px 22px 48px;
  }
`;

export const StyledButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: ${getToken('platform-font-title')};
  color: rgb(${getToken('color-text-primary')});
  background-color: rgb(${getToken('color-text-inverted')});
  font-weight: ${getToken('font-weight-bold')};
  text-transform: none;
  border-radius: 4px;
  margin: 0;
  padding: 16px;
  font-size: 16px;
  line-height: 16px;

  transition: all 0.1s ease-in-out;

  &:hover,
  &:active {
    background: rgb(${getToken('color-background-tertiary')});
  }
`;

export const Image = styled.div`
  width: 100%;
  min-height: 480px;
  background-color: rgb(${getToken('color-success-60')});
  background-image: url(/${(props) => props.bg.small});
  background-position: center center;
  background-size: cover;

  ${screen.md} {
    background-image: url(/${(props) => props.bg.medium});
  }

  ${screen.lg} {
    background-image: url(/${(props) => props.bg.large});
  }

  ${screen.xxlg} {
    background-image: url(/${(props) => props.bg.xxlarge});
  }
`;
